import React, { Component } from "react";
import { Form, Table } from "react-bootstrap";

import MenuItem from "@material-ui/core/MenuItem";
import { FormControl, Select, InputLabel } from "@material-ui/core";
import { NavLink } from "react-router-dom";
import LeftSideNavigation from "../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../navigationSection/RightSideNavigation";
// import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import Media from "react-media";
import Pagination from "rc-pagination";
import { TopNavigationBarMobile } from "../navigationSection/TopNavigationBarMobile";
import { BottomNavigationMobile } from "../navigationSection/BottomNavigationMobile";
import { RightSideCountTop } from "../../superAdminComponents/superAdminAllComponent/superAdminReports/orderingReports/SuperAdminPendingOrderActivityReports";
import moment from 'moment';

export default function  PendingOrderReport(props) {
  return (
    <React.Fragment>
      <div className="container-fluid superadmin-orderscomponent-main super-admin-vendor-private-orders">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation />
          </div>
          <div className="top-panel">
            <TopNavigationBarMobile displayLeft="logo" />
          </div>
          <div className="right-side-panel">
            <RightSideNavigation />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">
                Pending Order Report
                </div>
                <div>
                  <div className="f14-500 mb-2 d-flex justify-content-end align-items-end" style={{ color: "#EE3A23" }}>
                    {moment().format('lll')}
                  </div>
                  <RightSideCountTop
                    content={[
                        {
                            name: "Net Order Value",
                            value: "₹ 72,332",
                            backgroundColor: "#D8F3F4",
                            color: "#138B90",
                          },
                      {
                        name: "Pending Orders",
                        value: "40",
                        backgroundColor: "#FFEDE9",
                        color: "#EE3A23",
                      },
                      
                    ]}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-4">
                  <Form.Control
                    type="text"
                    placeholder="Search"
                    // onChange={props.onChange}
                    // value={props.search}
                    className="amSearch"
                  />
                </div>
                <div className="col-3"></div>
                <div className="col-3">
                  <div className="mr-3">
                    <FormControl variant="outlined" fullWidth>
                      <InputLabel id="demo-simple-select-outlined-label">
                        Select date range
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        value={""}
                        onChange={() => {}}
                        label="date_range"
                      >
                        <MenuItem value="">Last 30 days</MenuItem>
                      </Select>
                      <p>Select date range</p>
                    </FormControl>
                  </div>
                </div>
                <div className="col-2">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="f10-400" align="center">
                      <img
                        src={require("../../../assets/images/iconButton/sorticon.png")}
                        width="35px"
                      />
                      <br />
                      Sort
                    </div>
                    <div className="f10-400" align="center">
                      <img
                        src={require("../../../assets/images/iconButton/filtericon.png")}
                        width="35px"
                      />
                      <br />
                      Filter
                    </div>
                    <div className="f10-400" align="center">
                      <img
                        src={require("../../../assets/images/iconButton/downloadicon.png")}
                        width="35px"
                      />
                      <br />
                      Download
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className="col-12 p-0 user-table-reusable-superadmin table-responsive">
                  <Table className="HideShowTable enMinWidth900">
                  <thead style={{fontSize:'10px'}}>
                      <tr className="super_admin_all_users_table_head">
                        <th style={{ width: "300px" }} className="f12-700">
                        Order Type/ <br />
                        Order ID
                        </th>
                        <th style={{ width: "278px" }} className="f12-700">
                        User
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                        Order <br />Reference
                        </th>
                        <th style={{ width: "20%" }} className="f12-700">
                        Order Status /<br />Date & Time
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                        No of <br />Items
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                        Gross<br /> Amount
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                        Net Order<br /> Value
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                        GST
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                        Surcharges
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                        CC Charges
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                        Net <br />Remitted
                        </th>
                        <th style={{ width: "15%" }} className="f12-700">
                        Discount
                        </th>
                        <th style={{ width: "20%" }} className="f12-700">
                        Tip
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                        Donation
                        </th>
                        <th style={{ width: "20%" }} className="f12-700">
                        Payment Stats/<br /> Date & Time
                        </th>
                        <th style={{ width: "20%" }} className="f12-700">
                        Payment Method/<br /> Transaction ID
                        </th>
                        
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="super_admin_all_users_table_body">
                        <td style={{ width: "10%" }} className="f12-500">
                          <div className="super-admin-suggestion-table-body-boxone d-flex align-items-center">
                            <div className="super-admin-suggestion-imageBoxTwo ml-2">
                              <div className="f12-400">
                              Takeaway
                                <br />
                                1245789632
                              </div>
                            </div>
                          </div>
                        </td>
                        <td style={{ width: "278px" }} className="f12-500">
                        Ryan DiMascio
                        </td>
                        <td style={{ width: "10%" }} className="f12-500">
                        NA
                        </td>
                        <td style={{ width: "20%" }} className="f12-500">
                        <div className="super-admin-suggestion-imageBoxTwo ml-2">
                        <div className="badge badge-warning p-2" style={{borderRadius:'1rem',color:'white'}}>Pending</div>
                              <div className="f12-400">
                                25th aug 2020
                                <br />
                                09.15 PM
                              </div>
                            </div>
                        </td>
                        <td style={{ width: "10%" }} className="f12-500">
                        3
                        </td>
                        <td style={{ width: "10%" }} className="f12-500">
                        ₹ 1540
                        </td>
                        <td style={{ width: "10%" }} className="f12-500">
                        ₹ 1540
                        </td>
                        <td style={{ width: "10%" }} className="f12-500">
                        ₹ 50
                        </td>
                        <td style={{ width: "15%" }} className="f12-500">
                        ₹ 20
                        </td>
                        <td style={{ width: "10%" }} className="f12-500">
                        -
                        </td>
                        <td style={{ width: "10%" }} className="f12-500">
                        ₹ 50
                        </td>
                        <td style={{ width: "15%" }} className="f12-500">
                        ₹ 50
                        </td>
                        <td style={{ width: "20%" }} className="f12-500">
                        ₹ 30
                        </td>
                        <td style={{ width: "10%" }} className="f12-500">
                        ₹ 30
                        </td>
                        <td style={{ width: "20%" }} className="f12-500">
                        <div className="super-admin-suggestion-imageBoxTwo ml-2">
                        <div className="badge badge-success p-2" style={{borderRadius:'1rem'}}>Paid</div>
                              <div className="f12-400">
                                25th aug 2020
                                <br />
                                09.15 PM
                              </div>
                            </div>
                          
                        </td>
                        <td style={{ width: "20%" }} className="f12-500">
                        <b>Debit Card</b><br />
                        12345678
                        </td>
                      
                       
                      </tr><br />
                      <tr className="super_admin_all_users_table_body">
                        <td style={{ width: "10%" }} className="f12-500">
                          <div className="super-admin-suggestion-table-body-boxone d-flex align-items-center">
                            <div className="super-admin-suggestion-imageBoxTwo ml-2">
                              <div className="f12-400">
                              Takeaway
                                <br />
                                1245789632
                              </div>
                            </div>
                          </div>
                        </td>
                        <td style={{ width: "278px" }} className="f12-500">
                        Ryan DiMascio
                        </td>
                        <td style={{ width: "10%" }} className="f12-500">
                        NA
                        </td>
                        <td style={{ width: "20%" }} className="f12-500">
                        <div className="super-admin-suggestion-imageBoxTwo ml-2">
                        <div className="badge badge-warning p-2" style={{borderRadius:'1rem',color:'white'}}>Pending</div>
                              <div className="f12-400">
                                25th aug 2020
                                <br />
                                09.15 PM
                              </div>
                            </div>
                        </td>
                        <td style={{ width: "10%" }} className="f12-500">
                        3
                        </td>
                        <td style={{ width: "10%" }} className="f12-500">
                        ₹ 1540
                        </td>
                        <td style={{ width: "10%" }} className="f12-500">
                        ₹ 1540
                        </td>
                        <td style={{ width: "10%" }} className="f12-500">
                        ₹ 50
                        </td>
                        <td style={{ width: "15%" }} className="f12-500">
                        ₹ 20
                        </td>
                        <td style={{ width: "10%" }} className="f12-500">
                        -
                        </td>
                        <td style={{ width: "10%" }} className="f12-500">
                        ₹ 50
                        </td>
                        <td style={{ width: "15%" }} className="f12-500">
                        ₹ 50
                        </td>
                        <td style={{ width: "20%" }} className="f12-500">
                        ₹ 30
                        </td>
                        <td style={{ width: "10%" }} className="f12-500">
                        ₹ 30
                        </td>
                        <td style={{ width: "20%" }} className="f12-500">
                        <div className="super-admin-suggestion-imageBoxTwo ml-2">
                        <div className="badge badge-danger p-2" style={{borderRadius:'1rem'}}>Pay Later</div>
                              <div className="f12-400">
                                25th aug 2020
                                <br />
                                09.15 PM
                              </div>
                            </div>
                          
                        </td>
                        <td style={{ width: "20%" }} className="f12-500">
                        <b>Debit Card</b><br />
                        12345678
                        </td>
                       
                       
                      </tr><br />
                      <tr className="super_admin_all_users_table_body">
                        <td style={{ width: "10%" }} className="f12-500">
                          <div className="super-admin-suggestion-table-body-boxone d-flex align-items-center">
                            <div className="super-admin-suggestion-imageBoxTwo ml-2">
                              <div className="f12-400">
                              Takeaway
                                <br />
                                1245789632
                              </div>
                            </div>
                          </div>
                        </td>
                        <td style={{ width: "278px" }} className="f12-500">
                        Ryan DiMascio
                        </td>
                        <td style={{ width: "10%" }} className="f12-500">
                        NA
                        </td>
                        <td style={{ width: "20%" }} className="f12-500">
                        <div className="super-admin-suggestion-imageBoxTwo ml-2">
                        <div className="badge badge-warning p-2" style={{borderRadius:'1rem',color:'white'}}>Pending</div>
                              <div className="f12-400">
                                25th aug 2020
                                <br />
                                09.15 PM
                              </div>
                            </div>
                        </td>
                        <td style={{ width: "10%" }} className="f12-500">
                        3
                        </td>
                        <td style={{ width: "10%" }} className="f12-500">
                        ₹ 1540
                        </td>
                        <td style={{ width: "10%" }} className="f12-500">
                        ₹ 1540
                        </td>
                        <td style={{ width: "10%" }} className="f12-500">
                        ₹ 50
                        </td>
                        <td style={{ width: "15%" }} className="f12-500">
                        ₹ 20
                        </td>
                        <td style={{ width: "10%" }} className="f12-500">
                        -
                        </td>
                        <td style={{ width: "10%" }} className="f12-500">
                        ₹ 50
                        </td>
                        <td style={{ width: "15%" }} className="f12-500">
                        ₹ 50
                        </td>
                        <td style={{ width: "20%" }} className="f12-500">
                        ₹ 30
                        </td>
                        <td style={{ width: "10%" }} className="f12-500">
                        ₹ 30
                        </td>
                        <td style={{ width: "20%" }} className="f12-500">
                        <div className="super-admin-suggestion-imageBoxTwo ml-2">
                        <div className="badge badge-success p-2" style={{borderRadius:'1rem'}}>Paid</div>
                              <div className="f12-400">
                                25th aug 2020
                                <br />
                                09.15 PM
                              </div>
                            </div>
                          
                        </td>
                        <td style={{ width: "20%" }} className="f12-500">
                        <b>Debit Card</b><br />
                        12345678
                        </td>
                       
                       
                      </tr><br />
                      
                    </tbody>
                  </Table>
                </div>
              </div>

              <div className="p4v2-menu-pagination">
                <Pagination
                  onChange={() => {}}
                  current={1}
                  defaultPageSize={10}
                  total={15}
                  showTitle={false}
                />
              </div>
            </div>
          </div>
          <Media query="(max-width: 991px)">
            <div className="bottom-panel">
              <BottomNavigationMobile />
            </div>
          </Media>
        </div>
       
      </div>
    </React.Fragment>
  );
}

// export default PendingOrderReport;
